var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-forum center"},[_c('br'),_c('ATitle',{attrs:{"text":"第二届长三角综合交通发展大会"}}),_c('br'),_c('div',{staticClass:"forum-content rich-text",domProps:{"innerHTML":_vm._s(_vm.info.content)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }